import { MuiTheme } from "theme";
import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { EFlagPriority, flagLevels } from "components/VetExamsTable/helper";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;
  const { lowest, medium, highest } = flagLevels;

  return {
    flaggedButton: {
      fontSize: 12,
      width: 107,
      height: 24,
      borderRadius: 3,
      color: primary.dark,
      border: `1px solid ${primary.light}`,
      "&.active": {
        color: "#fff"
      },
      "& .MuiButton-startIcon": {
        marginRight: 6
      },
      "& .MuiSvgIcon-root": {
        fontSize: 14,
        position: "relative",
        bottom: 1
      },
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        height: 21,
        width: 100
      }
    },
    [EFlagPriority.LOWEST]: {
      borderColor: "#bea900",
      backgroundColor: lowest,
      "&.active": {
        color: "#6F5D00"
      },
      "&:hover": {
        backgroundColor: lowest
      }
    },
    [EFlagPriority.MEDIUM]: {
      borderColor: "#b00015",
      backgroundColor: medium,
      "&:hover": {
        backgroundColor: medium
      }
    },
    [EFlagPriority.HIGHEST]: {
      borderColor: "#4d008a",
      backgroundColor: highest,
      "&:hover": {
        backgroundColor: highest
      }
    },
    loader: {
      paddingLeft: 50,
      justifyContent: "start"
    }
  };
});
